import { apiClientes } from "../config/api";
import { Mensagem } from "../interfaces/entities/SaudeBemEstar/ChatComEquipeGC/Mensagem";
import { MessageToSend } from "../interfaces/entities/SaudeBemEstar/ChatComEquipeGC/MessageToSend";
import { Response } from "../interfaces/services/Response";
import { getTokenClientes } from "../Store/storages/AuthenticationStorage";

export const getConversasPersonal = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/PlanoMais/GetConversaMsgN0`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getAnexoMensagemPersonal = async (message: Mensagem): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/PlanoMais/GetAnexo`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      params: { idMsg: message.idMensagem, idAnexo: message.idAnexo }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const getMensagensPersonal = async (idMsg: number): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/PlanoMais/GetConversaMsg`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` },
      params: { idMsg }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const enviarMensagemPersonal = async (mensagem: MessageToSend): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/PlanoMais/EnviarMensagem',
      {
        idOrigem: mensagem.idMsgOrigem,
        mensagem: mensagem.mensagem,
        anexoB64: mensagem.anexoB64,
        nomeAnexo: mensagem.nomeAnexo,
        idDestinatario: mensagem.idDestinatario
      },
      {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` }
      });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};